export default "__VITE_ASSET__jd1d$0Zm__"